import { Assignee } from 'src/app/models/assignee';

export class AssigneeSalary {
    public assignee: Assignee;
    public salary: number;
    public endDate: Date;
    public dailyGrossUp: number;
}
